<div class="tab-pane" role="tabpanel" id="tiporecep">
    <fieldset id="agregar_tiporecep" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>

                    <div class="form-horizontal">

                        <div class="form-group" align="left">
                            <div class="col-sm-2">
                                <label for="option">Tipo de solicitud:</label>
                            </div>
                            <div class="col-sm-3" class="inline">
                                <form [formGroup]="form">
                                    <mat-radio-group formControlName="option" (change)="add_tipo_recepcion($event)">
                                        <mat-radio-button name="option" style="padding-left: 15px; padding-right: 20px" labelPosition='after' *ngFor="let tipo of tipos; let i = index" [value]="tipo">{{tipo}}</mat-radio-button>
                                    </mat-radio-group>
                                </form>


                            </div>
                            <div class="col-sm-4"></div>

                        </div>
                    </div>
                    <br>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>